import { CommunicationResource } from "../locales";

export const communication: CommunicationResource = {
    digitalMaterial: "Digitalt materiell",
    tastings: "Smakinger",
    storeMaterial: "Butikkmateriell",
    campaignMaterial: "Kampanjemateriell",
    news: "Nyheter",
};
